module.exports = __webpack_public_path__ + "img/wallet.4d30ac0.png";